import type { SearchQuery } from "@sunrise/backend-types";
import { atom } from "jotai";

/**
 * It's not possible to find live events. We can either show future stuff or past stuff.
 */
export const searchActiveFilterAtom = atom<SearchQuery["filter"]>("past");
